module.exports = __webpack_public_path__ + "img/empty_icon.47348054.png";